<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('header')">
      <div :class="b('header-start')">
        <h2 :class="b('title')">{{ $t("Мои активы") }}</h2>

        <div :class="b('tabs')">
          <button
            :class="b('tab', { active: tab.active })"
            v-for="tab in displayedTabs"
            :key="tab.id"
            @click="handleTab(tab.value)"
          >
            {{ $t(tab.label) }}
          </button>
        </div>
      </div>

      <button :class="b('statement')" @click="handleStatement">
        {{ $t("Выписка") }}
      </button>
    </div>

    <WalletMainTable :list="list" :filter-key="tab" />
  </div>
</template>
